<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						문자 보내기
						<small class="text-nomal m-l-10">보내는 사람 : {{mberName}} {{mobileNum}}</small>
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
						<button class="btn-sm round">
							<img src="images/w-setting.png" width="18" alt="" style="margin-top: -2px;"> 관리
						</button>
					</div>
				</div>
				<div class="modal-body p-10 text-center clearfix">
					<div class="send-box left">
						<h3 class="send-tit"><span>받는사람</span></h3>
						<div class="send-search-box clearfix">
							<div class="search-box pull-left">
								<input id="search" class="form-control round full-width m-b-0" type="text" v-model="searchKeyword">
								<label for="search" @click="searchMember()">검색</label>
								<ul :class="`item feature_search_id ${isSearching ? 'on' : ''}`" @click="$event.stopPropagation()">
									<li v-for="member in searchedMember" :key="`mobile-search-member-info-${hash(member)}`" @click="addSendList(member.mberName, member.mobileNum)">
										<span class="name">{{member.mberName}}</span> <span class="info">{{member.mobileNum}}</span>
									</li>
									<li v-if="isSearching && searchedMember.length == 0">
										해당 조건으로 검색된 회원이 없습니다
									</li>
								</ul>
							</div>
							<button class="btn bg-darkgray text-white plus round pull-right f-16" type="button" @click="addSendListBySms()">&nbsp;+&nbsp;</button>
						</div>
						<ul class="item-list" :key="hash(sendList)">
							<li v-for="(smsItem, index) in sendList" :key="`sendList-${hash(smsItem)}-${index}`">
								<span class="name" v-if="smsItem.name||smsItem.mberName">{{smsItem.mberName?smsItem.mberName:smsItem.name}}</span> <span class="info">{{smsItem.mobileNum}}</span>
								<a class="minus" @click="removeSendList(index)"></a>
							</li>
						</ul>
					</div>
					<div class="send-box right">
						<h3 class="send-tit"><span>양식 목록</span></h3>
						<div class="send-search-box half-width clearfix">
							<div class="search-box pull-left">
								<input id="search" class="form-control round full-width m-b-0" type="text" v-model="templKeyword" @keydown.enter="getSmsTamplate">
							</div>
							<button class="btn bg-darkgray plus round pull-right f-12" type="button" @click="getSmsTamplate">
								<img class="v-mid" src="images/search.png" width="15" alt="" style="margin-top: -2px;">
							</button>
						</div>
						<div class="half-width m-t-10 pull-left">
							<table class="table table-hover">
								<thead>
									<tr class="bg-lightgray">
										<th></th>
										<th>내용</th>
										<th>관리</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(template, idx) in templateList" :key="`sms-template-${idx}`"
										@click="smsMessage = template.content">
										<td>
											<input :id="`star-check-${idx}`" class="checkbox star" @change="toggleFavorite(template)"
												type="checkbox" :checked="template.favorite">
											<label :for="`star-check-${idx}`">즐겨찾기</label>
										</td>
										<td class="ellipsis">{{template.content}}</td>
										<td>
											<button class="btn-sm round" type="button" v-if="!template.shareEnable"
												@click="shareTamplate(template, $event)">공유하기</button>
											<span v-if="template.shareEnable">나에게 공유됨</span>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td colspan="3">
										<ctrl-pagination :currentPage="offset / pageSize + 1"
											:pageSize="pageSize" :totalCount="totalCount"
											:key="hash({pageSize, offset, totalCount})"
											@pageChanged="onPageChanged"></ctrl-pagination>
										</td>
									</tr>
								</tfoot>
							</table>
						</div>
						<div class="half-width m-t-10 pull-left">
							<div class="sms-box">
								<div class="sms-text-box m-b-5">
									<textarea class="m-t-10" cols="30" rows="11" v-model="smsMessage"></textarea>
									<span class="limit-text clearfix">
										<span class="pull-right">
											{{smsMessage.length}}/80<br>SMS
										</span>
									</span>
									<div class="send-box m-b-10 full-width">
										<div class="send-search-box clearfix">
											<div class="search-box full-width pull-left">
												<input class="form-control round full-width m-b-0" type="text" placeholder="양식 제목" v-model="smsSubject">
											</div>
										</div>
									</div>
									<div class="input-group full-width">
										<span class="input-group-addon">
											<button class="btn-sm round full-width" type="button" @click="saveTemplate"> 양식 저장 </button>
										</span>
										<span class="input-group-addon p-l-5">
											<button class="btn-sm bg-red text-white round full-width" type="button" @click="sendSMS"> 보내기
											</button>
										</span>
									</div>
								</div>
							</div>
							<div class="reserv-send" style="width:auto;">
								<input id="table-check10" class="checkbox" type="checkbox" v-model="isReservation">
								<label for="table-check10">체크버튼</label>
								<span class="m-r-5">예약전송</span>
								<VueCtkDateTimePicker v-model="rsrvDate" :no-label="true" :position="'-100'"
									formatted="YYYY-MM-DD HH:mm:ss" :right="true"
									class="_date-time-picker m-r-5 m-b-0"></VueCtkDateTimePicker>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios';
import server from '../statics/server';
import CtrlPagination from '../components/CtrlPagination.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
	name: "ModalSms",
	components: {
		CtrlPagination,
		VueCtkDateTimePicker
	},
	mounted: function() {
		axios.post(server.addr()+server.api.AUTHORIZATION).then( response => {
			this.mberName = response.data.return.mberName;
			this.mobileNum = response.data.return.mobileNum;
		});
		this.getSmsTamplate();
		if(this.config.msg)
			this.smsMessage = this.config.msg;
	},
	watch: {
		"config.msg": function(newValue) {
			this.smsMessage = newValue;
		}
	},
	default: function() {
		return {
			name: this.name,
			show: false,
			sendList: [],
			msg: ""
		}
	},
	data: function() {
		return {
			keyword: "",
			offset: 0,
			pageSize: 10,
			totalCount: 0,

			isReservation: false,
			rsrvDate: "",
			smsMessage: "",
			smsSubject: "",

			searchedMember: [],
			templateList: [],
			sendList: JSON.parse(JSON.stringify(this.config.sendList)),
			isSearching: false,	// 유저 모달 띄워주기 위한 flag
			searchKeyword: "", // 회원검색어
			templKeyword: "", // 양식검색어

			mberName: "",
			mobileNum: "",
		}
	},
	props: {
		config: Object
	},
	methods: {
		getSmsTamplate: async function() {
			try {
				const { offset, pageSize } = this;

				const { data } = await axios.post(`${server.addr()}${server.api.SMS_TEMPLATE}`, {
					keyword:this.templKeyword, offset, pageSize, orderBy:"A.REG_DATE DESC"
				});

				this.templateList = data.list;
				this.totalCount = parseInt(data.filtered);
			} catch (e){ e }
		},
		validateMobileNum: function(mobileNum) {
			const mobileRegx = /^01[0,1,3,5,7,8,9]\d{7,8}$/;
			return !mobileNum || !mobileRegx.test(mobileNum);
		},
		// 선택한 이SMS 삭제
		removeSendList: function(index) {
			this.sendList.splice(index, 1);
		},
		// 비회원 이SMS 전송
		addSendListBySms: function() {
			if(this.validateMobileNum(this.searchKeyword)) return;
			this.sendList.push({name: "", mobileNum: this.searchKeyword});
			this.searchKeyword = "";
			this.isSearching = false;
		},
		// 회원 중 이SMS 보낼사람 추가
		addSendList: function(mberName, mobileNum) {
			this.sendList.push({name:mberName, mobileNum:mobileNum});
		},
		// 멤버 찾기 버튼을 눌렀을 시
		searchMember: async function() {
			try {
				const { data } = await axios.post(`${server.addr()}${server.api.MBER}`, {
					offset: 0,
					keyword: this.searchKeyword,
					pageSize: 5,
					orderBy: "MBER_ID"
				});

				this.isSearching = true;
				this.searchedMember = data.list;
			} catch(e) {
				//eslint-disable-next-line
				console.warn(e);
				// TODO: error exception
			}
		},
		toggleFavorite: async function(template) {
			try {
				if(!template.favorite) {
					await axios.put(`${server.addr()}${server.api.SMS_FAVORITE}`, [{ "smsTemplId": template.smsTemplId }]);
				} else {
					await axios.put(`${server.addr()}${server.api.SMS_FAVORITE}/${template.smsTemplId}`, {});
				}
				template.favorite = !template.favorite;
			} catch(e) {
				// TODO: error e
			}
		},
		shareTamplate: async function(template, event) {
			event.stopPropagation();
			try {
				await axios.patch(`${server.addr()}${server.api.SMS_TEMPLATE}/${template.smsTemplId}`, {
					"shareEnable": 1
				});
				template.shareEnable = true;
				this.getSmsTamplate();
			} catch(e) {
				// TODO: error e
			}
		},
		saveTemplate: async function() {
			try {
				const { smsSubject, smsMessage } = this;

				await axios.put(`${server.addr()}${server.api.SMS_TEMPLATE}`, [{
					title: smsSubject,
					content: smsMessage
				}]);

				this.getSmsTamplate();
				this.$emit("onDone", "저장되었습니다.")
				// TODO: data.filter
			} catch (e){ e }
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getSmsTamplate();
		},
		sendSMS: async function() {
			const { smsMessage, isReservation, rsrvDate, sendList } = this;
			try {
				await axios.put(`${server.addr()}${server.api.SMS_SEND}`, {
					smsTxt:smsMessage, reqDate:isReservation?rsrvDate:null, callToList:sendList.map(e=>e.mobileNum)
				});

				this.$emit("onDone", "문자가 전송되었습니다.");
			} catch(e) {
				this.$emit("onDone", "문자 전송에 실패했습니다. 잠시 후 다시 시도해주세요.");
			}
		}
	}
}
</script>

<style scoped>
._date-time-picker {
	display: inline-block;
	width: 250px;
}
.ellipsis{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.feature_search_id.on {
	z-index: 1 !important;
	display: block !important;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>